import { render, staticRenderFns } from "./edge.vue?vue&type=template&id=7e56e6ea&scoped=true&"
import script from "./edge.vue?vue&type=script&lang=js&"
export * from "./edge.vue?vue&type=script&lang=js&"
import style0 from "./edge.vue?vue&type=style&index=0&id=7e56e6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56e6ea",
  null
  
)

export default component.exports